import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CommunityRoutingModule } from './community-routing.module';
import { CommunityComponent } from './community/community.component';
import { FoundationComponent } from './foundation/foundation.component';
import { CricketComponent } from './cricket/cricket.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';



@NgModule({
  declarations: [CommunityComponent, FoundationComponent, CricketComponent],
  imports: [
    CommonModule,
    SlickCarouselModule,
    CommunityRoutingModule,
    SharedModule,
    FormsModule,
    MomentModule
  ]
})
export class CommunityModule { }
